// components/dashboard/EntryExitActivity.js
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { GeoAlt, ArrowRight, ArrowLeft } from "react-bootstrap-icons";
import { getEntryExitActivity } from "../../services/Networkcall";
import { errorAlert } from "../common/Alert";
import CustomPagination from "../common/CustomPagination";
import moment from "moment";
import { Loader } from "../common/Loader";


const EntryExitActivity = ({ activityKey = "" }) => {

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({ page: 1,limit:5, totalPages: 0, totalRecords: 0 });

  const fetchEntryExitActivity = async () => {
    setLoading(true);
    if(activityKey === "entry"){ setPagination((prev) => ({ ...prev,limit: 10 })); }
    try {
      const limit = activityKey === "entry" ? 10 : 5;
      const res = await getEntryExitActivity({ page: pagination.page, limit });
      if (res?.success) {
        setData(res?.data);
        setPagination((prev) => ({ ...prev, totalPages: res?.totalPages, totalRecords: res?.totalRecords }));
      } else {
        errorAlert({ message: res?.message || "Failed to fetch entry/exit activity data" });
      }
    } catch (err) {
      errorAlert({ message: err?.message || err?.response?.data?.message|| "Failed to fetch entry/exit activity data" });
      console.error("Error fetching entry/exit activity:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEntryExitActivity();
  }, [pagination?.page, activityKey]);

  const pageHandler = (page) => {
    setPagination((pre) => ({ ...pre, page: page }));
  }

  

  return (
    <div className="entry-card">
      <Loader show={loading} />

      {/* Header */}
      <div className="entry-header">
        <h5>Entry & Exit Activity</h5>
      </div>

      {/* Table */}
      <Table className="entry-table align-middle" responsive>
        <thead>
          <tr>
            <th>TIME</th>
            <th>DRIVER</th>
            <th className="text-nowrap">TRUCK / PLATE</th>
            <th>YARD</th>
            <th>ACTIVITY</th>
            <th className="text-nowrap">GATE CODE</th>
          </tr>
        </thead>

        <tbody>
          {data?.length > 0 ? (
            data?.map((item, i) => (
              <tr key={i}>

                {/* Time + Dot */}
                <td>
                  <div className="time-cell text-nowrap">
                    <span className={`dot ${item.dot}`}></span>
                    {moment(item?.eventTime?.$date || item?.eventTime).tz(item?.detectedLocation?.timezone || "UTC").format("MMMM DD, hh:mm A")}
                  </div>
                </td>

                {/* Driver */}
                <td>{item?.driver?.userName}</td>

                {/* Truck */}
                <td>
                  <div>{item?.truck?.name || ""}</div>
                  <div className="sub-text">{item?.vehicle?.plate || ""}</div>
                </td>

                {/* Yard */}
                <td>
                  <div className="yard">
                    <GeoAlt size={14} />
                    {item?.detectedLocation?.locationName || ""}
                  </div>
                </td>

                {/* Activity */}
                <td>
                  <div className={`activity ${item.type}`}>
                    {item?.activity === "ENTRY" && (<> <ArrowRight size={16} /> Entry  </>)}
                    {item?.activity === "EXIT" && (<>  <ArrowLeft size={16} /> Exit </>)}
                  </div>
                </td>

                {/* Gate Code */}
                <td>
                  {item?.gateCode && <span className="gate-box">{item?.gateCode || ""}</span>}
                </td>

              </tr>
            ))) : (
            <tr>
              <td colSpan="6" className="text-center mx-auto py-4">
                No entry/exit activity found.
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {/* Pagination */}
      <CustomPagination
        pagination={pagination}
        pageHandler={pageHandler}
      />

    </div>
  );
};

export default EntryExitActivity;